"use client";

import { useTranslation } from "react-i18next";
import FAQSection from "@/components/sections/FAQSection";
import PitchPageHero from "@/components/pitches/PitchPageHero";
import PitchGallery from "@/components/pitches/PitchGallery";
import PitchVenueDetails from "@/components/pitches/PitchVenueDetails";
import PitchAboutSection from "@/components/pitches/PitchAboutSection";
import PitchPricingSection, {
  type PitchPricingRow,
} from "@/components/pitches/PitchPricingSection";
import { NEW_IMAGES } from "@/lib/images";

const PRICING_DATA: PitchPricingRow[] = [
  { timeKey: "pricingPage.table.luVi712", regular: 26000, vip10: 23400, vip15: 22100 },
  { timeKey: "pricingPage.table.luVi1218", regular: 38000, vip10: 34200, vip15: 32300 },
  { timeKey: "pricingPage.table.luVi1801", regular: 47000, vip10: 42300, vip15: 39950 },
  { timeKey: "pricingPage.table.sab712", regular: 26000, vip10: 23400, vip15: 22100 },
  { timeKey: "pricingPage.table.sab1201", regular: 47000, vip10: 42300, vip15: 39950 },
  { timeKey: "pricingPage.table.dom712", regular: 26000, vip10: 23400, vip15: 22100 },
  { timeKey: "pricingPage.table.dom1201", regular: 47000, vip10: 42300, vip15: 39950 },
];

export default function SyntheticFutsal3Page() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white pb-20">
      <PitchPageHero
        eyebrowKey="chips.synthetic"
        titleKey="canchaPitchPage.titleSynthetic"
        descriptionKey="chooseCards.card2Desc"
        shareTitleKey="chooseCards.card2Title"
        ratingScore={4.8}
        reviewCount={84}
      />

      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <PitchGallery images={[...NEW_IMAGES.synthetic]} />

        <PitchVenueDetails sportsDescription={t("canchaDetails.syntheticSports")} />

        <PitchAboutSection>
          <span className="mb-3 block">{t("canchaPitchPage.syntheticAboutP1")}</span>
          <span className="mb-3 block">{t("canchaPitchPage.syntheticAboutP2")}</span>
          <span className="mb-2 mt-6 block font-semibold text-slate-800">
            {t("canchaPitchPage.syntheticRulesTitle")}
          </span>
          <span className="block">- {t("canchaPitchPage.syntheticRule1")}</span>
          <span className="block">- {t("canchaPitchPage.syntheticRule2")}</span>
          <span className="block">- {t("canchaPitchPage.syntheticRule3")}</span>
        </PitchAboutSection>

        <PitchPricingSection
          rows={PRICING_DATA}
          pricingSubtitle={t("canchaPitchPage.pricingSubtitleSynthetic", {
            timeLabel: t("pricingPage.table.time"),
          })}
        />
      </div>

      <div className="mt-20">
        <FAQSection />
      </div>
    </div>
  );
}
